import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import withStyles from "react-jss";
import Button from "ComponentsUI/Button";

const styles = (theme) => {
	return {
		root: {
			width: "100%",
			marginBottom: "60px",
			"&:last-child": {
				marginBottom: 0,
			},
		},
		header: {
			fontFamily: theme.fonts.bold,
			fontSize: "18px",
			lineHeight: "2",
			letterSpacing: "2px",
			color: theme.palette.colors.darkSlateBlue,
			marginBottom: "45px",
			textTransform: "uppercase",
			position: "relative",
			marginLeft: "30px",
			"&:after": {
				content: '""',
				position: "absolute",
				width: "79px",
				height: "2px",
				left: 0,
				bottom: "-10px",
				backgroundColor: theme.palette.colors.purplishBlue,
			},
		},
		body: {},
		wrapper: {
			display: "flex",
			alignItems: "center",
		},
		item: {
			display: "flex",
			justifyContent: "space-between",
			alignItems: "flex-start",
			marginBottom: "20px",
			"&:last-child": {
				marginBottom: 0,
			},
		},
		itemLeftPart: {
			fontFamily: theme.fonts.medium,
			fontSize: "14px",
			lineHeight: "1.29",
			letterSpacing: "2px",
			color: theme.palette.colors.oneMoreGrey,
			textTransform: "uppercase",
			marginRight: "32px",
		},
		itemRightPart: {
			fontFamily: theme.fonts.bold,
			fontSize: "16px",
			lineHeight: "1.13",
			color: theme.palette.colors.darkSlateBlue,
		},
		itemRightPartHref: {
			color: theme.palette.colors.purplishBlue,
			textDecoration: "none",
			"&:hover": {
				color: theme.palette.colors.purplishBlue,
			},
		},
		button: {
			width: "280px",
			marginRight: "60px",
		},
		[`@media (min-width: ${theme.media.md}) and (max-width: ${theme.media.lg})`]: {
			root: {
				paddingLeft: 0,
			},
			itemRightPart: {
				fontSize: "15px",
			},
		},
		[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
			root: {},
			header: {
				marginLeft: "21px",
				fontSize: "16px",
			},
		},
		[`@media (max-width: ${theme.media.sm})`]: {
			root: {
				marginBottom: "40px",
			},
			header: {
				fontSize: "16px",
				lineHeight: "1.12",
				marginBottom: "20px",
				marginLeft: 0,
				"&:after": {
					display: "none",
				},
			},
			wrapper: {
				flexWrap: "wrap",
			},
			body: {
				width: "100%",
			},
			item: {
				justifyContent: "space-between",
			},
			itemLeftPart: {
				width: "auto",
				marginRight: "12px",
				marginBottom: "5px",
			},
			itemRightPart: {
				width: "auto",
			},
			button: {
				width: "100%",
				marginBottom: "30px",
				marginRight: 0,
			},
		},
	};
};

class ContactsBlock extends React.Component {
	static defaultProps = {
		classes: {},
		header: null,
		data: [],
	};

	generateItems() {
		const { classes } = this.props;

		return this.props.data.map((item, index) => {
			return (
				<div className={classes.item} key={index}>
					<div className={classes.itemLeftPart}>{item.name}</div>
					{!item.isEmail && <div className={classes.itemRightPart}>{item.value}</div>}
					{item.isEmail && (
						<a
							href={`mailto:${item.value}`}
							className={classNames(classes.itemRightPart, classes.itemRightPartHref)}
						>
							{item.value}
						</a>
					)}
				</div>
			);
		});
	}

	static propTypes = {
		text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
		header: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
		data: PropTypes.array,
	};

	render() {
		let classes = this.props.classes;
		return (
			<div className={classes.root}>
				<div className={classes.header}>{this.props.header}</div>
				<div className={classes.wrapper}>
					{!!this.props.buttonName && (
						<div className={classes.button}>
							<Button
								typeText="big"
								component={this.props.buttonLink}
								size={"middle"}
								status={"tertiaryAccent"}
								transparent={true}
								fullWidth={true}
							>
								{this.props.buttonName}
							</Button>
						</div>
					)}
					<div className={classes.body}>{this.generateItems()}</div>
				</div>
			</div>
		);
	}
}
export default withStyles(styles)(ContactsBlock);
